module.exports = __webpack_public_path__ + "img/Asset 11@4x.9916dc92.png";